import { analyticsHelpers, constants } from 'day8-ui';
import { updateSearch } from './querystring';
import {
  COUNTRYEMOJIS
} from '../constants';
import { getCountryCode } from './country';

const { TYW_DESTINATION } = constants;

/**
 * Shown when a destination has no photo set in admin. Every destination photo now comes from
 * the Destination record, so this is the only hardcoded destination image left in the app.
 */
export const DEFAULT_DESTINATION_IMAGE = 'https://cdn.theyachtweek.com/assets/booking-funnel/confirm-sidebar/diving-girls-1.jpg';

/**
 * Resolve a destination's photo URL.
 *
 * Accepts either shape a destination arrives in: `img` on the yacht-list destinations
 * payload, or `photoUrl` on a serialized Destination entity (bookings, crew finders).
 *
 * @param {object} destination
 * @returns {string}
 */
export const getDestinationImage = destination =>
  (destination && (destination.img || destination.photoUrl)) || DEFAULT_DESTINATION_IMAGE;

export const onDestinationSelect = (destination, location, history, pathname) => {
  if (destination && location && history && pathname) {
    analyticsHelpers.selectedDestination({
      destination_name: destination.name,
      destination_id: destination.id
    });
    history.push({
      pathname,
      search: updateSearch(location, { dest: destination.id, weeks: undefined })
    });
  }
};

const FLAGS_BY_COUNTRY = {
  HR: COUNTRYEMOJIS.CROATIA,
  GR: COUNTRYEMOJIS.GREECE,
  IT: COUNTRYEMOJIS.ITALY,
  BS: COUNTRYEMOJIS.BAHAMAS,
  MQ: COUNTRYEMOJIS.STLUCIA + COUNTRYEMOJIS.FRANCE,
  PF: COUNTRYEMOJIS.FRENCHPOLYNESIA,
  ME: COUNTRYEMOJIS.MONTENEGRO
};

export const countryEmojiFlagSelect = destination => {
  const byCountry = FLAGS_BY_COUNTRY[getCountryCode(destination)];
  if (byCountry) {
    return byCountry;
  }
  switch (destination.id) {
  case TYW_DESTINATION.CROATIA_ORIGINAL:
  case TYW_DESTINATION.CROATIA_DUBROVNIK:
  case TYW_DESTINATION.CROATIA_ULTRA:
  case TYW_DESTINATION.CROATIA_HIDEOUT:
  case TYW_DESTINATION.YNF_CROATIA:
  case TYW_DESTINATION.CROATIA_NAMASTE:
  case TYW_DESTINATION.YACHTNIK_CROATIA:
    return COUNTRYEMOJIS.CROATIA;
  case TYW_DESTINATION.GREECE:
  case TYW_DESTINATION.GREECE_REVIVE:
  case TYW_DESTINATION.YNF_GREECE:
  case TYW_DESTINATION.YNF_PC_GREECE:
    return COUNTRYEMOJIS.GREECE;
  case TYW_DESTINATION.ITALY:
    return COUNTRYEMOJIS.ITALY;
  case TYW_DESTINATION.BAHAMAS:
    return COUNTRYEMOJIS.BAHAMAS;
  case TYW_DESTINATION.ST_LUCIA_MARTINIQUE:
    return COUNTRYEMOJIS.STLUCIA + COUNTRYEMOJIS.FRANCE;
  case TYW_DESTINATION.TAHITI:
  case TYW_DESTINATION.YNF_TAHITI:
    return COUNTRYEMOJIS.FRENCHPOLYNESIA; // Tahiti
  case TYW_DESTINATION.MONTENEGRO:
  case TYW_DESTINATION.YNF_PC_MONTENEGRO:
    return COUNTRYEMOJIS.MONTENEGRO;
  default: return '';

  }
};